import { render, staticRenderFns } from "./DamagedStorage.vue?vue&type=template&id=4751ef03&scoped=true&"
import script from "./DamagedStorage.vue?vue&type=script&lang=js&"
export * from "./DamagedStorage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4751ef03",
  null
  
)

export default component.exports